/**
 * Opening copy for vacation chat (widget + public page).
 * Shown only when there are no messages yet in the thread.
 */
export const CUSTOMER_VACATION_CHAT_WELCOME_TEXT =
  "שלום, אני כאן כדי למצוא לכם חופשה מתאימה\n\n" +
  "אפשר לבחור יעד מהרשימה או לכתוב חופשי, למשל:\n" +
  "חופשה באוגוסט לזוג עם ילדים\n\n" +
  "לאן תרצו לטוס?";
